import { ModalProps } from "antd";
import AntModal from "./DraggableModal";   // talabnoma §8.2 (2026-09-06): siljitiladigan modal
import React from "react";
import useQueryParams from "../../hooks/useQueryParams";
import { useQuickFilters } from "../../contexts/HeaderExtrasContext";   // s42

export interface IModalProps extends ModalProps {
  matcher: string;
  removeParamsOnClose?: string[];
}

const Modal: React.FC<IModalProps> = ({
  children,
  matcher,
  removeParamsOnClose = [],
  ...props
}) => {
  const query = useQueryParams();
  const extras = useQuickFilters(matcher || "filtering");   // tog'a #1931: faqat o'z matcher'ining filtrlari
  const isFilter = /filtering$/i.test(matcher || "");   // tog'a #1931 (2026-09-14): "debtFiltering" — katta F, regex katta-kichik harfga sezgir edi → quick-filters bloki chizilmasdi
  return (
    <AntModal
      destroyOnClose
      // Msg 214: to'liq-ekran Drawer forma modalini bosib qo'yardi — "Добавить bosilmayabdi" ning asl sababi.
      // tog'a #2231 (2026-09-21): qavat endi DraggableModal ichida hisoblanadi (`modalZ()` — ochiq eng ustki
      // drawer'dan baland), shuning uchun bu yerda qat'iy 1010 yozilmaydi.
      {...props}
      visible={query.has(matcher)}
      onCancel={() => query.removeMany(matcher, ...removeParamsOnClose)}>
      {isFilter && extras.length > 0 && (
        <div className="quick-filters">{extras.map((x: any, i: number) => <div className="quick-filter-item" key={x?.key ?? i}>{x}</div>)}</div>
      )}
      {children}
    </AntModal>
  );
};

export default Modal;
